import { env } from '@shared/config/env';

export const apiImageUrl = (value?: string): string | undefined => {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;
  if (/^\/?images\//.test(value)) {
    const key = value.replace(/^\/?images\//, '');
    return `${env.apiUrl}/public/images/${encodeURIComponent(key)}`;
  }
  if (value.startsWith('/')) return new URL(value, `${env.apiUrl}/`).toString();
  return `${env.apiUrl}/public/images/${encodeURIComponent(value)}`;
};
